(function () {
  var STORAGE_KEY = 'aldo_collection_mobile_cols';
  var DEFAULT_COLS = '2';

  function getCols() {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_COLS;
    } catch (e) {
      return DEFAULT_COLS;
    }
  }

  function setCols(cols) {
    try {
      localStorage.setItem(STORAGE_KEY, cols);
    } catch (e) {
      // no-op
    }
  }

  function applyToGrid(cols) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    grid.classList.remove('collection-layout--1-col-mobile', 'collection-layout--2-col-mobile');
    grid.classList.add(cols === '1' ? 'collection-layout--1-col-mobile' : 'collection-layout--2-col-mobile');
  }

  function syncButtons(cols) {
    var buttons = document.querySelectorAll('.collection-layout-toggle__btn[data-collection-layout-cols]');
    buttons.forEach(function (btn) {
      var active = btn.getAttribute('data-collection-layout-cols') === cols;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function apply(cols) {
    applyToGrid(cols);
    syncButtons(cols);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.collection-layout-toggle__btn[data-collection-layout-cols]');
    if (!btn) return;
    var cols = btn.getAttribute('data-collection-layout-cols') === '1' ? '1' : '2';
    setCols(cols);
    apply(cols);
  });

  document.addEventListener('DOMContentLoaded', function () {
    apply(getCols());

    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    var observer = new MutationObserver(function () {
      apply(getCols());
    });
    observer.observe(container, { childList: true, subtree: true });
  });
})();
